import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, RequestOptions, ResponseContentType, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/forkJoin'
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { GlobalProvider } from "../../providers/global/global";
import { Observable } from 'rxjs/Observable';

 //let this.global.apiUrl = 'https://api.picmasters.de.w016f694.kasserver.com/api/';
 //
 // let this.global.apiUrl = 'https://api.picmasters.de/api/';
  // let this.global.apiUrl = 'http://plentyclip.apps/api/';
@Injectable()
export class OrdersProvider {
 
	data: any;

	locale: string;

  constructor(public http: Http, public storage: Storage, public translate: TranslateService, public global: GlobalProvider) {
  	let locale = this.translate.currentLang;
  	this.locale = locale;
  }

  getPartners(){ 
  
    return new Promise((resolve, reject) => {
 	console.log("GET PARTNERS");

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	 		//alert('Get Order with token:' + token);
	      this.http.get(this.global.apiUrl+'partners', {headers: headers})
	        .map(res => res.json())
	        .subscribe(data => {      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }

  getCampaignsDashboard(){ 
  
    return new Promise((resolve, reject) => {

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      let params = new URLSearchParams();

	 		//alert('Get Order with token:' + token);
	      this.http.get(this.global.apiUrl+'campaigns-dashboard', {headers: headers})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }

  getCrm(page, order_id, search_Status, search_Internal_Status, sort_orders_created_by, search, searchField, limit, search_Image_Internal_Status, search_locale, from, to, apply_date_on){ 
  
    return new Promise((resolve, reject) => {
 	console.log("ORDER ID", order_id);

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      let params = new URLSearchParams();
	      	//params.append('with', 'images;template');
    		params.append('page', page);
    		if (order_id && order_id != '') {
    			params.append('order_id', order_id);
    		}
    		
    		if (search_Status && search_Status != '') {
    			params.append('status', search_Status);
    		}

    		if (search_Internal_Status && search_Internal_Status != '') {
    			params.append('internal_status', search_Internal_Status);
    		}

    		if (sort_orders_created_by && sort_orders_created_by != '') {
    			params.append('orderBy', 'id');
    			params.append('sortedBy', sort_orders_created_by);
    		}

    		if (search_Image_Internal_Status && search_Image_Internal_Status != '') {
    			params.append('image.internal_status', search_Image_Internal_Status);
    		}

    		if (search_locale && search_locale != '') {
    			params.append('locale', search_locale);
    		}

    		if (from && from != '') {
    			params.append('from', from);
    		}

    		if (to && to != '') {
    			params.append('to', to);
    		}

    		if (apply_date_on && apply_date_on != '') {
    			params.append('apply_date_on', apply_date_on);
    		}
    		
    		

    		if (search && search != '') {
    			params.append('search', search);
    			if (searchField && searchField != '' && searchField != 'all') {
    				if (searchField == 'id') {
    					params.append('searchFields', searchField + ':=');
    				}else{
    					params.append('searchFields', searchField + ':like');
    				}
    				
    			}
    			
    		}

    		if (limit && limit != '') {
    			params.append('limit', limit);
    		}
    		

	 		//alert('Get Order with token:' + token);
	      this.http.get(this.global.apiUrl+'crm', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }




  getStreamOrders(page, order_id, search_Status, search_Internal_Status, sort_orders_created_by, search, searchField, limit, search_Image_Internal_Status){ 
 
    return new Promise((resolve, reject) => {
 	console.log("ORDER ID", order_id);

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      let params = new URLSearchParams();
	      	//params.append('with', 'images;template');
    		params.append('page', page);
    		if (order_id && order_id != '') {
    			params.append('order_id', order_id);
    		}
    		
    		if (search_Status && search_Status != '') {
    			params.append('status', search_Status);
    		}

    		if (search_Internal_Status && search_Internal_Status != '') {
    			params.append('internal_status', search_Internal_Status);
    		}

    		if (sort_orders_created_by && sort_orders_created_by != '') {
    			params.append('orderBy', 'id');
    			params.append('sortedBy', sort_orders_created_by);
    		}

    		if (search_Image_Internal_Status && search_Image_Internal_Status != '') {
    			params.append('image.internal_status', search_Image_Internal_Status);
    		}

    		

    		if (search && search != '') {
    			params.append('search', search);
    			if (searchField && searchField != '') {
    				params.append('searchFields', searchField + ':like');
    			}
    			
    		}

    		if (limit && limit != '') {
    			params.append('limit', limit);
    		}
    		

	 		//alert('Get Order with token:' + token);
	      this.http.get(this.global.apiUrl+'stream', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }
  

  getUserOrder(order_id){
 
    return new Promise((resolve, reject) => {
 	console.log("ORDER ID", order_id);

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      let params = new URLSearchParams();
	      	//params.append('with', 'images;template');
    		params.append('page', "1");
    		if (order_id && order_id != '') {
    			params.append('order_id', order_id);
    		}
    		
	 		//alert('Get Order with token:' + token);
	      this.http.get(this.global.apiUrl+'user-order', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }


  getAdminOrders(page, order_id){
 
    return new Promise((resolve, reject) => {
 	console.log("ORDER ID", order_id);

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      let params = new URLSearchParams();
	      	//params.append('with', 'images;template');
    		params.append('page', page);
    		if (order_id && order_id != '') {
    			params.append('order_id', order_id);
    		}
    		
	 		//alert('Get Order with token:' + token);
	      this.http.get(this.global.apiUrl+'orders', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }

  getStreamStats(){
 
    return new Promise((resolve, reject) => {
 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      this.http.get(this.global.apiUrl+'stream-stats', {headers: headers})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }

  downloadAllOrderImages(order_id,offset){ 
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);

	      let params = new URLSearchParams();
	      	//params.append('with', 'images;template');
    		params.append('order_id', order_id);
    		params.append('offset', offset);
	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.get(this.global.apiUrl+'download-all-order-images', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  downloadReportFile(from, to){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);

	      let params = new URLSearchParams();
	      	//params.append('with', 'images;template');
    		params.append('from', from);
    		params.append('to', to);


	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.get(this.global.apiUrl+'download-upload-report', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }
  
  downloadRejectionReportFile(from, to){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);

	      let params = new URLSearchParams();
	      	//params.append('with', 'images;template');
    		params.append('from', from);
    		params.append('to', to);


	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.get(this.global.apiUrl+'download-rejection-report', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

 sendMailsForUserList(users:any, type:string){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);

	      this.http.post(this.global.apiUrl+'send-mails/'+type, JSON.stringify(users), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  updateOrder(order){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.post(this.global.apiUrl+'reject-image', JSON.stringify(order), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  rejectAdminImage(image){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.post(this.global.apiUrl+'reject-image', JSON.stringify(image), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  scheduleArchiving(order){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.post(this.global.apiUrl+'schedule-archiving', JSON.stringify(order), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  createBankTransferInvoice(user_id:number, inputData:string, order_id:number = null){ //order_id not implemented yet. Reserverved for later if direct payment by wire transfer gets implemented
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	      this.http.post(this.global.apiUrl+'create-wire-transfer-invoice', JSON.stringify({user_id: user_id, transferData:inputData, order_id:order_id}), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  updateOperatorOrder(order_id:number, key:string, value:string){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.post(this.global.apiUrl+'update-order-by-operator', JSON.stringify({id: order_id, key:key, value: value}), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  approveOperatorOrder(order){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.post(this.global.apiUrl+'approve-order-by-operator', JSON.stringify(order), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  rejectOperatorOrder(order){
	return new Promise((resolve, reject) => {
  this.storage.get('token').then((token) => {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		headers.append('X-localization', this.translate.currentLang);
		   //TODO HERE !! CREATE ROUTE IN APP
		this.http.post(this.global.apiUrl+'reject-order-by-operator', JSON.stringify(order), {headers: headers})
		  .map(res => res.json())
		  .subscribe(res => {
			resolve(res);
		  }, (err) => {
			reject(err);
		  });
	   });
  });
}


  rejectOperatorImage(image){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.post(this.global.apiUrl+'reject-image-by-operator', JSON.stringify(image), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  completePreProcessing(order){
  	return new Promise((resolve, reject) => {
	this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.translate.currentLang);
	 		//TODO HERE !! CREATE ROUTE IN APP
	      this.http.post(this.global.apiUrl+'complete-preprocessing', JSON.stringify(order), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  

  getPreProcessingRejectionOrders(page, customParam){
 
    return new Promise((resolve, reject) => {
 

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      let params = new URLSearchParams();
	      	//params.append('with', 'images;template');
    		params.append('page', page);
    		params.append('customParam', customParam);
	 		//alert('Get Order with token:' + token);
	      this.http.get(this.global.apiUrl+'preprocessing-image-rejections', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  }

  getPreProcessingOrders(page, customParam){
 
    return new Promise((resolve, reject) => {
 

 	this.storage.get('token').then((token) => {
	      let headers = new Headers();

	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      let params = new URLSearchParams();
	      	//params.append('with', 'images;template');
    		params.append('page', page);
    		params.append('customParam', customParam);
	 		//alert('Get Order with token:' + token);
	      this.http.get(this.global.apiUrl+'preprocessing-orders', {headers: headers, params: params})
	        .map(res => res.json())
	        .subscribe(data => {
	      
	          resolve(data.data);
	        }, (err) => {
	          reject(err);
	        });
	    });
 	});
 
  } 
 
  completePreProcessingImageRejection(image){
  	return new Promise((resolve, reject) => {
 		this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);
	 
	      this.http.post(this.global.apiUrl+'complete-image-rejection-preprocessing', JSON.stringify(image), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  markPayoutAsPaid(payout){
  	return new Promise((resolve, reject) => {
 		this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      this.http.post(this.global.apiUrl+'set-payout-paid', JSON.stringify(payout), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  blockOrder(order){
  	return new Promise((resolve, reject) => {
 		this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);

	      this.http.post(this.global.apiUrl+'block-order', JSON.stringify(order), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }

  completeOrder(order){
  	return new Promise((resolve, reject) => {
 		this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('X-Requested-With', 'XMLHttpRequest');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);
	 
	      this.http.post(this.global.apiUrl+'complete-order', JSON.stringify(order), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });
  }
 	
 getFile(path: string):Observable<any>{
    let options = new RequestOptions({responseType: ResponseContentType.Blob});
    return this.http.get(path, options)
        .map((response: Response) => <Blob>response.blob())  ;
  }

  uploadImageByUrl(imageUpload) {

  	return new Promise((resolve, reject) => {
 		this.storage.get('token').then((token) => {
	      let headers = new Headers();
	      headers.append('Content-Type', 'application/json');
	      headers.append('Authorization', 'Bearer ' + token);
	      headers.append('X-localization', this.locale);
	 
	      this.http.post(this.global.apiUrl+'upload-image', JSON.stringify(imageUpload), {headers: headers})
	        .map(res => res.json())
	        .subscribe(res => {
	          resolve(res.data);
	        }, (err) => {
	          reject(err);
	        });
 		});
    });

  }

  regenerateImagesByUrl(image) {

	return new Promise((resolve, reject) => {
	   this.storage.get('token').then((token) => {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		headers.append('X-localization', this.locale);
   
		this.http.post(this.global.apiUrl+'upload-image', JSON.stringify(image), {headers: headers})
		  .map(res => res.json())
		  .subscribe(res => {
			resolve(res.data);
		  }, (err) => {
			reject(err);
		  });
	   });
  });

}

	setAdminId(payload){
		return new Promise((resolve, reject) => {
			this.storage.get('token').then((token) => {
				let headers = new Headers();
				headers.append('Content-Type', 'application/json');
				headers.append('Authorization', 'Bearer ' + token);
				headers.append('X-localization', this.locale);
		
				this.http.post(this.global.apiUrl+'set-admin-id', JSON.stringify(payload), {headers: headers})
				.map(res => res.json())
				.subscribe(res => {
					resolve(res.data);
				}, (err) => {
					reject(err);
				});
			});
		});
	}

	setCampaignId(payload){
		return new Promise((resolve, reject) => {
			this.storage.get('token').then((token) => {
				let headers = new Headers();
				headers.append('Content-Type', 'application/json');
				headers.append('Authorization', 'Bearer ' + token);
				headers.append('X-localization', this.locale);
		
				this.http.post(this.global.apiUrl+'set-campaign-id', JSON.stringify(payload), {headers: headers})
				.map(res => res.json())
				.subscribe(res => {
					resolve(res.data);
				}, (err) => {
					reject(err);
				});
			});
		});
	}

	setImageStatus(payload, type) {

		return new Promise((resolve, reject) => {
		this.storage.get('token').then((token) => {
			let headers = new Headers();
			headers.append('Content-Type', 'application/json');
			headers.append('Authorization', 'Bearer ' + token);
			headers.append('X-localization', this.locale);
	
			this.http.post(this.global.apiUrl+'set-image-status/' + type, JSON.stringify(payload), {headers: headers})
			.map(res => res.json())
			.subscribe(res => {
				resolve(res.data);
			}, (err) => {
				reject(err);
			});
		});
	});

	}

  

  //New 
  uploadMultipleImagesByUrl(images, orderId, token, upload_source, connector_id){
  		console.log('Run UPLOAD multiple Images');
     var arrObservables = []; 

     // this.storage.get('token').then((token) => {
     //let token = 'bla';
	     for(var i = 0; i < images.length; i++){
	     	let imageUpload = {
		  		upload_url: images[i].image_url,
		  		order_id: orderId,
		  		upload_source: upload_source,
		  		connector_id: connector_id,
		  		product_id: images[i].product_id,
		  		product_name: images[i].product_name,
		  		external_image_id: images[i].external_image_id
		  	}
		  	console.log('imageUpload Load created:', imageUpload);
		  	
		  		let headers = new Headers();
			      headers.append('Content-Type', 'application/json');
			      headers.append('Authorization', 'Bearer ' + token);
			      headers.append('X-localization', this.locale);

			      console.log('call upload image api');
		         arrObservables.push(
			         	this.http.post(this.global.apiUrl+'upload-image', JSON.stringify(imageUpload), {headers: headers})
			         	.map((res)=>{
			           return res.json()
			         }).catch((err)=>{
			           return Observable.throw(err);
			         })

			         // 	this.http.post(this.global.apiUrl+'images', JSON.stringify(imageUpload), {headers: headers}).map((res: Response)=>{
			         //   return res.json()
			         // }).catch((err: Response)=>{
			         //   return Observable.throw(err);
			         // })

		         )	    
	     }
	  // });
     return Observable.forkJoin(arrObservables);
    }
 
}


// WEBPACK FOOTER //
// ./src/providers/orders/orders.ts